import React from 'react';
import { Navigate } from 'react-router-dom';
import { auth } from '../utils/auth';
import './Login.css';

function Login() {
  // If already authenticated, redirect to dashboard
  if (auth.isAuthenticated()) {
    return <Navigate to="/dashboard" replace />;
  }

  const handleLogin = () => {
    auth.login();
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>Nuvia</h1>

        <div className="login-content">
          <button onClick={handleLogin} className="login-button">
            Anmelden
          </button>
        </div>

        <div className="login-footer">
          <p>made with &lt;3 by lolevel</p>
        </div>
      </div>
    </div>
  );
}

export default Login;
